/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export const minutesToMilliseconds = (minutes: number) => minutes * 60 * 1000;
